module.exports = __webpack_public_path__ + "img/ueberdachung_1.2eb68d48.jpg";